import React from "react";

import { cn } from "../../../common/u1/cn";
import {
  ArrowUpRight,
  CreditCardIcon,
  EditSquareIcon,
  ShieldIcon,
  StarIcon,
  UsersIcon,
} from "../../../../assets/ui/icons";
import { BENEFITS } from "./membershipFields";

/* The icons are named in membershipFields as strings so the content list stays
   free of JSX and can be asserted as data. */
const ICONS = {
  shield: ShieldIcon,
  rise: ArrowUpRight,
  star: StarIcon,
  card: CreditCardIcon,
  users: UsersIcon,
  edit: EditSquareIcon,
};

const BenefitCard = ({ benefit }) => {
  const Icon = ICONS[benefit.icon] || ShieldIcon;
  return (
    <div
      className={cn(
        "flex gap-3 rounded-[14px] border p-4",
        benefit.highlighted
          ? "border-[var(--coral-soft)] bg-[var(--coral-soft)]/40"
          : "border-[var(--line)] bg-white"
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px]",
          benefit.highlighted
            ? "bg-[var(--coral)] text-white"
            : "bg-[var(--field-inset)] text-[var(--muted)]"
        )}
      >
        <Icon size={16} />
      </span>
      <div className="min-w-0">
        <h3 className="m-0 text-[13.5px] font-bold text-[var(--ink)] font-sans">
          {benefit.title}
        </h3>
        <p className="m-0 mt-1 text-[12.5px] leading-[1.5] text-[var(--muted)] font-sans">
          {benefit.body}
        </p>
      </div>
    </div>
  );
};

/* Why anyone would upgrade. Six cards, the first tinted.
 *
 * One column on a phone rather than the live screen's fixed two — at 390px a
 * two-up grid puts three words on a line. */
export const BenefitGrid = ({ className = "" }) => (
  <section className={className}>
    <p className="m-0 text-[11px] font-bold uppercase tracking-[.11em] text-[var(--muted)] font-sans">
      What membership unlocks
    </p>
    <h2 className="m-0 mt-1.5 text-[20px] font-bold text-[var(--ink)] font-sans">
      Six reasons businesses upgrade
    </h2>

    <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
      {BENEFITS.map((benefit) => (
        <BenefitCard key={benefit.key} benefit={benefit} />
      ))}
    </div>
  </section>
);

export default BenefitGrid;
